import React, { memo } from 'react';
import { node, bool } from 'prop-types';
import classnames from 'classnames';

import './Label.scss';

const Label = ({
  children,
  active = false,
  disabled = false,
  filled = false,
  invalid = false,
  multiline = false,
  style,
}) => {
  const classes = classnames('ThemedTextField__Label', {
    'ThemedTextField__Label--active': active && !disabled,
    'ThemedTextField__Label--disabled': disabled,
    'ThemedTextField__Label--filled': filled,
    'ThemedTextField__Label--invalid': invalid,
    'ThemedTextField__Label--multiline': multiline,
  });

  return (
    <span className={classes} style={style}>
      {children}
    </span>
  );
};

Label.propTypes = {
  children: node,
  active: bool,
  disabled: bool,
  filled: bool,
  invalid: bool,
  multiline: bool,
};

export default memo(Label);
